'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _versionManager = require('./versionManager.js');

var _versionManager2 = _interopRequireDefault(_versionManager);

var _renderUtils = require('../utils/renderUtils');

var _WixSdkWrapper = require('../sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _featuresList = require('./featuresList');

var _featuresList2 = _interopRequireDefault(_featuresList);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _queryString = require('query-string');

var qs = _interopRequireWildcard(_queryString);

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getManualUpdatesData = function getManualUpdatesData() {
  var workerWindow = _renderUtils.renderUtils.getWorkerWindow();
  var manualUpdates = void 0;
  if (workerWindow) {
    var workerWindowData = _renderUtils.renderUtils.getGalleryDataFromWorker();
    manualUpdates = _lodash2.default.get(workerWindowData, 'window.gallerySettings.upgrades');
  }
  if (!manualUpdates) {
    manualUpdates = _lodash2.default.get(_renderUtils.renderUtils.getGallerySettingsFromWindow(), 'upgrades');
  }

  return manualUpdates;
};

var ProGalleryVersionManager = function () {
  function ProGalleryVersionManager(dateCreated, features) {
    (0, _classCallCheck3.default)(this, ProGalleryVersionManager);

    this.dateCreated = dateCreated;
    this.features = features;
    this.versionManager = new _versionManager2.default(features, dateCreated, getManualUpdatesData());
  }

  (0, _createClass3.default)(ProGalleryVersionManager, [{
    key: 'update',
    value: function update(dateCreated, manualUpdates) {
      this.dateCreated = dateCreated || this.dateCreated;
      this.versionManager.update(this.dateCreated, manualUpdates || getManualUpdatesData());
    }
  }, {
    key: 'setDateCreated',
    value: function setDateCreated(dateCreated) {
      this.dateCreated = dateCreated;
      this.versionManager = new _versionManager2.default(this.features, this.dateCreated);
    }
  }, {
    key: 'getFeaturesWithNewerVersions',
    value: function getFeaturesWithNewerVersions(upgrades) {
      var manualUpdates = getManualUpdatesData();
      var featuresWithNewerVersions = this.versionManager.getFeaturesWithNewerVersions(upgrades || manualUpdates);
      return _lodash2.default.isEmpty(featuresWithNewerVersions) ? null : featuresWithNewerVersions;
    }
  }, {
    key: 'getVersion',
    value: function getVersion(featureName) {
      return this.versionManager.getVersion(featureName);
    }
  }, {
    key: 'getFeature',
    value: function getFeature(featureName) {
      return this.versionManager.getFeature(featureName);
    }
  }]);
  return ProGalleryVersionManager;
}();

//If this is a template gallery, always use the lates version


var dateCreated = void 0;
var urlParams = void 0;
try {
  dateCreated = _windowWrapper2.default.dateCreated;
  urlParams = qs.parse(_windowWrapper2.default.location.search);

  if (_WixSdkWrapper2.default.Utils.getDemoMode()) {
    dateCreated = new Date().toString();
  }
} catch (e) {
  dateCreated = {};
  urlParams = '';
}

//For QA - when adding 'features_upgrade' to the debugApp, the gallery will load with the oldest features.
var debugApp = _lodash2.default.get(urlParams, 'debugApp');
if (debugApp && debugApp.indexOf('features_upgrade') > -1) {
  dateCreated = null;
}

var dateCreatedTicks = _renderUtils.renderUtils.getDateCreatedTicksFromStr(dateCreated);
var pgVersionManager = new ProGalleryVersionManager(dateCreatedTicks, _featuresList2.default);

module.exports = { ProGalleryVersionManager: ProGalleryVersionManager, pgVersionManager: pgVersionManager, VersionManagerCore: _versionManager2.default, featuresList: _featuresList2.default };